/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { apiClient } from './api'
import { handleError } from './error';
import type { AppDispatch, RootState } from '../reducers';
import type { ApiResponse } from '../types/api';

type GetState = () => RootState;
type ReportingFrameworksData = NonNullable<RootState['reportingFrameworks']['data']>;

export const loadReportingFrameworks = () => (dispatch: AppDispatch, getState: GetState) => {

  const reportingFrameworkState = getState().reportingFrameworks;
  if (reportingFrameworkState.loaded && reportingFrameworkState.reportType === 'taxonomy') {
    return;
  }

  dispatch({ type: actionTypes.LOADING_REPORTING_FRAMEWORKS, reportType: 'taxonomy' });

  apiClient.get<ApiResponse<ReportingFrameworksData>>('/reporting-frameworks/map')
    .then(response => {
      dispatch({
        type: actionTypes.LOADED_REPORTING_FRAMEWORKS,
        data: response.data.data,
        reportType: 'taxonomy'
      });
    })
    .catch(handleError(dispatch, actionTypes.ERROR_REPORTING_FRAMEWORKS))
};

export const loadReportingFrameworksByPrimaryConnections = () => (dispatch: AppDispatch, getState: GetState) => {

  const reportingFrameworkState = getState().reportingFrameworks;
  if (reportingFrameworkState.loaded && reportingFrameworkState.reportType === 'primary-connections') {
    return;
  }

  dispatch({ type: actionTypes.LOADING_REPORTING_FRAMEWORKS, reportType: 'primary-connections' });

  apiClient.get<ApiResponse<ReportingFrameworksData>>('/reporting-frameworks/map/adaptor')
    .then(response => {
      dispatch({
        type: actionTypes.LOADED_REPORTING_FRAMEWORKS,
        data: response.data.data,
        reportType: 'primary-connections'
      });
    })
    .catch(handleError(dispatch, actionTypes.ERROR_REPORTING_FRAMEWORKS))
};
